import React, {useState} from "react";
import downArrow from "../../Forexs/assets/downArrow.png";
import red from "../../Forexs/assets/red.png";
const RedBTCShort = () => {
  return (
    <div>
      <div className="pl-[14px] flex items-center justify-between pt-[10px] gradient-box  pb-[10px] pr-[22px] gap-2   bg-main-black rounded-[5px] h-[40px]">
        <div className="flex items-center">
          <div
            className={`w-[30px] md:w-[33px] h-[15px] md:h-[20px]  flex justify-center items-center rounded-[7px] bg-[#FB3F3F] `}
          >
            <img className="w-[14px]" src={downArrow} alt="arrow" />
          </div>
          <h2 className="uppercase text-xxs md:text-res-xs ml-[8px] md:ml-[17px] whitespace-nowrap font-semibold">
            btc{" "}
            <span
              className={` 
                     text-[#FB3F3F] `}
            >
              SHORT
            </span>
          </h2>
        </div>
        <div className="flex items-center gap-[13px]">
          <h2 className=" text-xxs md:text-res-xs font-semibold">$27,482.55</h2>
          <img className="w-[60px] md:w-[77px]" src={red} alt="chart" />
        </div>
      </div>
    </div>
  );
};

export default RedBTCShort;
